module.exports = __webpack_public_path__ + "static/media/arrow-link.586832d4.svg";